
#easm-dashboard-inventory-container {
  display: flex;
  flex-direction: row;
}

#container-title {
  width: 10%;
}

.clickable:hover,
.clickable:hover * {
  cursor: pointer;
  color: var(--blue-layout-400-primary);

  gz-text {
    color: var(--blue-layout-400-primary);
  }
}

:host {
  margin-top: -6px;
}

.containers-wrapper {
  display: contents;
}

.containers {
  display: grid;
  flex-basis: 20%;
}

.label {
  display: none;
  width: auto;
}

.value {
  margin-right: 15%;
  font-weight: 600;
  font-size: calc(12px + var(--dynamic-small-font-size-changer));
  font-family: var(--font-family-secondary-mono);
  min-width: fit-content;
  color: var(--main-titles-inputs-600);
}

.first-item {
  display: flex;
  gap: calc(var(--spacer));
  align-items: center;
  justify-content: center;
}

gz-tooltip {
  display: flex;
}

.icon-with-label {
  display: none;
}

@media screen and (min-width: 1168px) {
  .label {
    display: flex;
  }
  .icon-with-label {
    display: flex;
  }

  gz-tooltip {
    display: none;
  }
}
